module.exports = __webpack_public_path__ + "static/img/no1.db692457.png";